<script lang="ts">
	import { videoAction } from '../actions';
	import { stringArraySomeIncludes } from '../utils/arrays';
	import type { AdaptiveVideoSrc } from '../types/props';
	import { consentVendorsStore } from '@app/stores/consent';
	import ButtonBoxWhite from '../elements/buttons/variants/ButtonBoxWhite.svelte';
	import { getVendorName, enableVendor, getVendorId } from '@app/utils/didomi';
	import { t } from 'svelte-i18n';

	let videoFormats = ['mp4', 'webm', 'ogg', 'h264', 'vp9', 'hls'];

	export let src: AdaptiveVideoSrc;
	export let classNames: string = null;
	export let loop = false;
	export let autoplay = false;
	export let controls = false;
	export let muted = false;
	export let iframe = false;
	export let ratio = '';
	export let iframeTitle;

	let vendorId: string, vendorName: string, isConsent: boolean;

	const checkExtensionInSrc = (src) => {
		if (Array.isArray(src)) {
			let bool = false;
			src.forEach((s) => {
				stringArraySomeIncludes(videoFormats, s.url) && (bool = true);
			});
			return bool;
		} else if (typeof src !== 'string') {
			return stringArraySomeIncludes(videoFormats, src.url);
		} else {
			return stringArraySomeIncludes(videoFormats, src);
		}
	};

	$: if (iframe && src) {
		vendorId = getVendorId(src as string);
	}

	$: if ($consentVendorsStore !== {} && $consentVendorsStore[vendorId]) {
		isConsent = vendorId && $consentVendorsStore[vendorId].consent;
		vendorName = getVendorName(vendorId);
	}
</script>

{#if src}
	{#if checkExtensionInSrc(src)}
		<p class="text-danger">Please provide video url WITHOUT file extension.</p>
	{:else}
		<div class="relative w-full {ratio}">
			{#if iframe}
				{#if isConsent}
					<iframe
						use:videoAction={src}
						allow={`accelerometer; ${
							autoplay ? `autoplay; ` : ``
						}clipboard-write; encrypted-media; gyroscope; picture-in-picture allowfullscreen`}
						loading="lazy"
						title={iframeTitle}
						class={`${classNames} w-full ${ratio}`}
					/>
				{:else}
					<div
						class="flex flex-col bg-grey-dark opacity-70 items-center justify-center absolute w-full h-full top-0 left-0 space-y-2 lg:space-y-4"
					>
						{#if vendorName}
							<div class="text-xs lg:text-base text-center text-white w-11/12 lg:w-3/4">
								{@html $t('consent.videoProviderMessage', { values: { name: vendorName } })}
							</div>
							<ButtonBoxWhite
								props={{ label: $t('consent.watchVideoBtnLabel'), size: 'default' }}
								on:click={() => {
									enableVendor(vendorId);
								}}
							/>
						{/if}
					</div>
				{/if}
			{:else}
				<video
					use:videoAction={src}
					{autoplay}
					preload={autoplay ? 'auto' : 'none'}
					{controls}
					{loop}
					{muted}
					playsinline={autoplay}
				/>
			{/if}
		</div>
	{/if}
{:else}
	<p class="text-danger">Video url is missing. Please use <code>singleUrl</code> props.</p>
{/if}
